/**
 * Catalog import limits (CONF-242, ASVS 5.1.1). The cost worksheet and the
 * generic prices sheet are a few hundred rows (tens of KB); 5 MB is generous
 * headroom and small enough that a mis-chosen file cannot stall the browser.
 * ImportPage.jsx checks `file.size` before reading; the limits are documented
 * in docs/security/file-handling-limits.md.
 */
export const MAX_IMPORT_BYTES = 5 * 1024 * 1024;

export function importTooLargeMessage(name: string, size: number): string {
  return `${name} is ${(size / 1048576).toFixed(1)} MB; the import limit is 5 MB.`;
}
